// Consentmo-Cookie-Banner am Handy kompakter (nur unter 750 px, Desktop unverändert).
// Der Banner liegt im Shadow DOM von <csm-cookie-consent>, Theme-CSS erreicht ihn nicht.
// Deshalb wird ein <style> in das Shadow DOM gehängt. Nur feste Klassen (cc-*, csm-*), keine Hash-Klassen.
// „Ablehnen“ und „Annehmen“ bleiben gleich groß und gleich auffällig.
(function() {
  if (window.milCookieBannerBound) return;
  window.milCookieBannerBound = true;

  var STYLE_ID = 'mil-csm-mobil';
  var css = '@media screen and (max-width: 749px){' +
    '#csm-wrapper .cc-window.cc-window{left:8px!important;right:8px!important;bottom:8px!important;width:auto!important;max-width:none!important;transform:none!important}' +
    '#csm-wrapper .cc-window .csm-cmp-body.csm-cmp-body{padding:12px 14px!important;gap:10px!important}' +
    '#csm-wrapper .cc-window p.cc-message.cc-message{font-size:13px!important;line-height:1.4!important;padding-right:18px!important}' +
    '#csm-wrapper .cc-window .cc-message a{font-size:13px!important}' +
    '#csm-wrapper .cc-window .cc-compliance.cc-compliance{flex-direction:row!important;gap:6px!important}' +
    '#csm-wrapper .cc-window .cc-compliance .cc-btn.cc-btn{flex:1 1 0!important;min-width:0!important;width:auto!important;min-height:40px!important;padding:6px 4px!important;font-size:13px!important;margin:0!important}' +
    '}';

  function einfuegen(root) {
    if (root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    root.appendChild(style);
  }

  // true, sobald das Shadow DOM gefunden und dauerhaft beobachtet wird
  function anbinden() {
    var host = document.querySelector('csm-cookie-consent');
    var root = host && host.shadowRoot;
    if (!root) return false;
    einfuegen(root);
    // Falls Consentmo den Inhalt neu aufbaut, das Style-Element wieder einhängen
    new MutationObserver(function() { einfuegen(root); }).observe(root, { childList: true });
    return true;
  }

  if (anbinden()) return;
  var beobachter = new MutationObserver(function() {
    if (anbinden()) beobachter.disconnect();
  });
  beobachter.observe(document.documentElement, { childList: true, subtree: true });
  // Banner kommt nicht (z. B. Zustimmung schon erteilt): Beobachtung nach 30 s beenden
  setTimeout(function() { beobachter.disconnect(); }, 30000);
})();
